import { useEffect, FC, useState } from "react";

import { Row, Col, Breadcrumb, Typography, Menu, Avatar, Dropdown } from "antd";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import HeaderNotification from "components/Notification/HeaderNotification";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store";
import { sigOut } from "store/slices/authSlice";

interface HeaderProps {
  name?: string;
  onPress?: () => void;
}

const { Text } = Typography;

const flagTh = "https://flagcdn.com/w40/th.png";
const flagEn = "https://flagcdn.com/w40/gb.png";

const Header: FC<HeaderProps> = ({ name, onPress }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const [showMenu, setShowMenu] = useState(false);

  const profile = useAppSelector((state) => state.auth.profile);

  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();

  const [language, setLanguage] = useState<string>(i18n.language);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const languageMenu = (
    <Menu
      selectable
      defaultSelectedKeys={[""]}
      style={{ width: 220 }}
      items={[
        {
          key: "1",
          label: " ตั้งค่าโปรไฟล์",
          style: { color: "#417B97", borderRadius: 5 , marginTop: 5,  marginBottom: 5 , marginRight: 5, marginLeft: 5, alignContent: "center" },
          icon: (
            <div style={{ marginRight: 15 }}>
              <ProfileIcon color="#417B97" />
            </div>
          ),
          onClick: () => {
            navigate("/profiles/setting-my-profile");
          },
        },
        {
          key: "2",
          label: " ออกจากระบบ",
          style: { color: "red", border: "1px solid red", borderRadius: 5 , marginTop: 20,  marginBottom: 20 , marginRight: 20, marginLeft: 20,   },
          icon: (
            <div style={{ marginRight: 15,  }}>
              <SignOutIcon  color="red" />
            </div>
          ),
          onClick: () => {
            dispatch(sigOut());
          },
        },
      ]}
    />
  );

 

  return (
    <>
      <Row gutter={[24, 0]} justify={"center"}>
        <Col
          xs={{ span: 6 }}
          sm={{ span: 6 }}
          md={{ span: 6 }}
          lg={{ span: 0 }}
          style={{ marginTop: 10  }}
        >
          <IconWrapperHam
            onClick={() => {
              onPress && onPress();
            }}
          >
            <SpanIcon>
              <HamburgerIcon color={"#000"} />
            </SpanIcon>
          </IconWrapperHam>
        </Col>
        <Col
          lg={{ span: 6 }}
          sm={{ span: 0 }}
          span={0}
          style={{ marginTop: 10 }}
        >
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">{t("navHeader.home")}</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{name}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col
          xs={{ span: 18 }}
          md={{ span: 18 }}
          sm={{ span: 18 }}
          lg={{ span: 18 }}
          span={24}
          className="header-control"
        >
          <Dropdown overlay={languageMenu} trigger={["click"]}>
            <div style={{ marginRight: 15, paddingBottom: 5 }}>
              <Avatar
                size={"default"}
                shape="circle"
                src={profile?.user?.image_url}
              />
              <Typography.Text style={{ marginLeft: 10 }}>
                {profile?.user.first_name + " " + profile?.user.last_name}
              </Typography.Text>
            </div>
          </Dropdown>
          {/* <IconWrapper
            onClick={() => {
              navigate("/profiles");
            }}
          >
            <SpanIcon>
              <GearIcon color={page === "setting" ? "#417B97" : "#000"} />
            </SpanIcon>
            <Text style={{ color: page === "setting" ? "#417B97" : "#000" }}>
              {t("navHeader.setting")}
            </Text>
          </IconWrapper> */}
          {/* <IconWrapper
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            <SpanIcon>
              <HeaderNotification
                color={page === "notification" ? "#417B97" : "#000"}
                showMenu={showMenu}
              />
            </SpanIcon>
            <Text
              style={{ color: page === "notification" ? "#417B97" : "#000" }}
            >
               {t('navHeader.notifications')}
            </Text>
          </IconWrapper> */}
          {/* <IconWrapper
            onClick={() => {
              navigate("/chat");
            }}
          >
            <SpanIcon>
              <ChatIcon color={page === "chat" ? "#417B97" : "#000"} />
            </SpanIcon>
            <Text style={{ color: page === "chat" ? "#417B97" : "#000" }}>
            {t('navHeader.chat')}
            </Text>
          </IconWrapper> */}

          {/* <IconWrapper
            onClick={() => {
              navigate("/order");
            }}
          >
            <SpanIcon>
              <BillIcon color={page === "order" ? "#417B97" : "#000"} />
            </SpanIcon>
            <Text style={{ color: page === "order" ? "#417B97" : "#000" }}>
              {t("navHeader.order")}
            </Text>
          </IconWrapper> */}
          {/* <IconWrapper
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            <SpanIcon>
              <HomeIcon color={page === "dashboard" ? "#417B97" : "#000"} />
            </SpanIcon>
            <Text style={{ color: page === "dashboard" ? "#417B97" : "#000" }}>
              {t("navHeader.home")}
            </Text>
          </IconWrapper> */}
        </Col>
      </Row>
    </>
  );
};

interface IconProps {
  color?: string;
}

const HomeIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 24 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.459 0.660591C12.3259 0.556836 12.162 0.500488 11.9932 0.500488C11.8245 0.500488 11.6606 0.556836 11.5275 0.660591L0.75 9.06434L1.68225 10.2433L3 9.21584V18.5001C3.00079 18.8977 3.15908 19.2787 3.44022 19.5599C3.72135 19.841 4.10242 19.9993 4.5 20.0001H19.5C19.8976 19.9993 20.2787 19.841 20.5598 19.5599C20.8409 19.2787 20.9992 18.8977 21 18.5001V9.22259L22.3177 10.2501L23.25 9.07109L12.459 0.660591ZM13.5 18.5001H10.5V12.5001H13.5V18.5001ZM15 18.5001V12.5001C14.9996 12.1024 14.8414 11.7211 14.5602 11.4399C14.279 11.1587 13.8977 11.0005 13.5 11.0001H10.5C10.1023 11.0005 9.721 11.1587 9.43978 11.4399C9.15856 11.7211 9.0004 12.1024 9 12.5001V18.5001H4.5V8.04659L12 2.20409L19.5 8.05409V18.5001H15Z"
        fill={color}
      />
    </svg>
  );
};

const HamburgerIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.25C3 4.55964 3.55964 4 4.25 4H19.75C20.4404 4 21 4.55964 21 5.25C21 5.94036 20.4404 6.5 19.75 6.5H4.25C3.55964 6.5 3 5.94036 3 5.25ZM3 11.25C3 10.5596 3.55964 10 4.25 10H19.75C20.4404 10 21 10.5596 21 11.25C21 11.9404 20.4404 12.5 19.75 12.5H4.25C3.55964 12.5 3 11.9404 3 11.25ZM3 17.25C3 16.5596 3.55964 16 4.25 16H19.75C20.4404 16 21 16.5596 21 17.25C21 17.9404 20.4404 18.5 19.75 18.5H4.25C3.55964 18.5 3 17.9404 3 17.25Z"
        fill={color}
      />
    </svg>
  );
};

const ChatIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z"
        fill={color}
      />
      <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill={color} />
    </svg>
  );
};

const NotificationIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5303 14.4697L17.5 12.4395V9.75C17.4977 7.89138 16.8063 6.09964 15.5595 4.72124C14.3127 3.34284 12.5991 2.4757 10.75 2.2875V0.75H9.25V2.2875C7.40093 2.4757 5.68732 3.34284 4.44053 4.72124C3.19373 6.09964 2.50233 7.89138 2.5 9.75V12.4395L0.46975 14.4697C0.329088 14.6104 0.250042 14.8011 0.25 15V17.25C0.25 17.4489 0.329018 17.6397 0.46967 17.7803C0.610322 17.921 0.801088 18 1 18H6.25V18.5828C6.23369 19.5342 6.56905 20.4583 7.19184 21.1778C7.81462 21.8973 8.68102 22.3617 9.625 22.482C10.1464 22.5337 10.6728 22.4757 11.1704 22.3117C11.6681 22.1478 12.1259 21.8815 12.5144 21.53C12.9029 21.1785 13.2136 20.7495 13.4264 20.2707C13.6392 19.792 13.7494 19.2739 13.75 18.75V18H19C19.1989 18 19.3897 17.921 19.5303 17.7803C19.671 17.6397 19.75 17.4489 19.75 17.25V15C19.75 14.8011 19.6709 14.6104 19.5303 14.4697ZM12.25 18.75C12.25 19.3467 12.0129 19.919 11.591 20.341C11.169 20.7629 10.5967 21 10 21C9.40326 21 8.83097 20.7629 8.40901 20.341C7.98705 19.919 7.75 19.3467 7.75 18.75V18H12.25V18.75ZM18.25 16.5H1.75V15.3105L3.78025 13.2803C3.92091 13.1396 3.99996 12.9489 4 12.75V9.75C4 8.1587 4.63214 6.63258 5.75736 5.50736C6.88258 4.38214 8.4087 3.75 10 3.75C11.5913 3.75 13.1174 4.38214 14.2426 5.50736C15.3679 6.63258 16 8.1587 16 9.75V12.75C16 12.9489 16.0791 13.1396 16.2197 13.2803L18.25 15.3105V16.5Z"
        fill={color}
      />
    </svg>
  );
};

const BillIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2H4C3.44772 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22H5L6.5 20.5L8 22L9.5 20.5L11 22L12.5 20.5L14 22L15.5 20.5L17 22L18.5 20.5L20 22H21C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2H20ZM20 19L18.5 17.5L17 19L15.5 17.5L14 19L12.5 17.5L11 19L9.5 17.5L8 19L6.5 17.5L5 19V4H20V19ZM7 6H17V8H7V6ZM7 10H17V12H7V10ZM7 14H12V16H7V14Z"
        fill={color}
      />
    </svg>
  );
};

const GearIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.43 12.98C19.46 12.66 19.5 12.34 19.5 12C19.5 11.66 19.46 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.8 8.96 21.72 8.73L19.94 4.98C19.85 4.75 19.61 4.62 19.37 4.68L16.93 5.35C16.17 4.77 15.34 4.29 14.44 4L14 1.5H10L9.56 4C8.66 4.29 7.83 4.77 7.07 5.35L4.63 4.68C4.39 4.62 4.15 4.75 4.06 4.98L2.28 8.73C2.2 8.96 2.27 9.22 2.46 9.37L4.57 11.02C4.54 11.34 4.5 11.66 4.5 12C4.5 12.34 4.54 12.66 4.57 12.98L2.46 14.63C2.27 14.78 2.2 15.04 2.28 15.27L4.06 19.02C4.15 19.25 4.39 19.38 4.63 19.32L7.07 18.65C7.83 19.23 8.66 19.71 9.56 20L10 22.5H14L14.44 20C15.34 19.71 16.17 19.23 16.93 18.65L19.37 19.32C19.61 19.38 19.85 19.25 19.94 19.02L21.72 15.27C21.8 15.04 21.73 14.78 21.54 14.63L19.43 12.98ZM12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z"
        fill="none"
      />
    </svg>
  );
};

const ProfileIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.00049C8.74168 2.00049 9.4667 2.22042 10.0834 2.63248C10.7001 3.04453 11.1807 3.6302 11.4645 4.31543C11.7484 5.00065 11.8226 5.75465 11.6779 6.48208C11.5333 7.20951 11.1761 7.87769 10.6517 8.40214C10.1272 8.92659 9.45902 9.28374 8.73159 9.42843C8.00416 9.57313 7.25016 9.49887 6.56494 9.21504C5.87971 8.93121 5.29404 8.45056 4.88199 7.83388C4.46993 7.21719 4.25 6.49217 4.25 5.75049C4.25 4.75593 4.64509 3.8021 5.34835 3.09884C6.05161 2.39558 7.00544 2.00049 8 2.00049ZM8 0.500488C6.96165 0.500488 5.94661 0.808395 5.08326 1.38527C4.2199 1.96215 3.54699 2.78209 3.14963 3.7414C2.75227 4.70071 2.6483 5.75631 2.85088 6.77471C3.05345 7.79311 3.55346 8.72857 4.28769 9.4628C5.02191 10.197 5.95738 10.697 6.97578 10.8996C7.99418 11.1022 9.04978 10.9982 10.0091 10.6009C10.9684 10.2035 11.7883 9.53059 12.3652 8.66723C12.9421 7.80387 13.25 6.78884 13.25 5.75049C13.25 4.3581 12.6969 3.02274 11.7123 2.03818C10.7277 1.05361 9.39239 0.500488 8 0.500488ZM15.5 23.0005H14V19.2505C14 18.2559 13.6049 17.3021 12.9017 16.5988C12.1984 15.8956 11.2446 15.5005 10.25 15.5005H5.75C4.75544 15.5005 3.80161 15.8956 3.09835 16.5988C2.39509 17.3021 2 18.2559 2 19.2505V23.0005H0.5V19.2505C0.5 17.8581 1.05312 16.5227 2.03769 15.5382C3.02226 14.5536 4.35761 14.0005 5.75 14.0005H10.25C11.6424 14.0005 12.9777 14.5536 13.9623 15.5382C14.9469 16.5227 15.5 17.8581 15.5 19.2505V23.0005ZM15.5 3.50049H23V5.00049H15.5V3.50049ZM15.5 7.25049H23V8.75049H15.5V7.25049ZM15.5 11.0005H20.75V12.5005H15.5V11.0005Z"
        fill={color}
      />
    </svg>
  );
};

const SignOutIcon: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 20.7499H6C5.65324 20.7647 5.30697 20.7109 4.98101 20.5917C4.65505 20.4725 4.3558 20.2902 4.10038 20.0552C3.84495 19.8202 3.63837 19.5371 3.49246 19.2222C3.34654 18.9073 3.26415 18.5667 3.25 18.2199V5.77994C3.26415 5.43316 3.34654 5.09256 3.49246 4.77765C3.63837 4.46274 3.84495 4.17969 4.10038 3.9447C4.3558 3.70971 4.65505 3.52739 4.98101 3.40818C5.30697 3.28896 5.65324 3.23519 6 3.24994H9C9.19891 3.24994 9.38968 3.32896 9.53033 3.46961C9.67098 3.61027 9.75 3.80103 9.75 3.99994C9.75 4.19886 9.67098 4.38962 9.53033 4.53027C9.38968 4.67093 9.19891 4.74994 9 4.74994H6C5.70307 4.72412 5.4076 4.81359 5.17487 4.99977C4.94213 5.18596 4.78999 5.45459 4.75 5.74994V18.2199C4.78999 18.5153 4.94213 18.7839 5.17487 18.9701C5.4076 19.1563 5.70307 19.2458 6 19.2199H9C9.19891 19.2199 9.38968 19.299 9.53033 19.4396C9.67098 19.5803 9.75 19.771 9.75 19.9699C9.75 20.1689 9.67098 20.3596 9.53033 20.5003C9.38968 20.6409 9.19891 20.7199 9 20.7199V20.7499Z"
        fill={color}
      />
      <path
        d="M16 16.7499C15.9015 16.7504 15.8038 16.7312 15.7128 16.6934C15.6218 16.6556 15.5392 16.6 15.47 16.5299C15.3296 16.3893 15.2507 16.1987 15.2507 15.9999C15.2507 15.8012 15.3296 15.6105 15.47 15.4699L18.94 11.9999L15.47 8.52991C15.3963 8.46125 15.3372 8.37845 15.2962 8.28645C15.2552 8.19445 15.2332 8.09513 15.2314 7.99443C15.2296 7.89373 15.2482 7.7937 15.2859 7.70031C15.3236 7.60692 15.3797 7.52209 15.451 7.45087C15.5222 7.37965 15.607 7.32351 15.7004 7.28579C15.7938 7.24807 15.8938 7.22954 15.9945 7.23132C16.0952 7.23309 16.1945 7.25514 16.2865 7.29613C16.3785 7.33712 16.4613 7.39622 16.53 7.46991L20.53 11.4699C20.6705 11.6105 20.7493 11.8012 20.7493 11.9999C20.7493 12.1987 20.6705 12.3893 20.53 12.5299L16.53 16.5299C16.4608 16.6 16.3782 16.6556 16.2872 16.6934C16.1962 16.7312 16.0985 16.7504 16 16.7499Z"
        fill={color}
      />
      <path
        d="M20 12.75H9C8.80109 12.75 8.61032 12.671 8.46967 12.5303C8.32902 12.3897 8.25 12.1989 8.25 12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25H20C20.1989 11.25 20.3897 11.329 20.5303 11.4697C20.671 11.6103 20.75 11.8011 20.75 12C20.75 12.1989 20.671 12.3897 20.5303 12.5303C20.3897 12.671 20.1989 12.75 20 12.75Z"
        fill={color}
      />
    </svg>
  );
};

export default Header;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #EFEFEF;
  }
  onSelect={handleSidenavColor}
`;

const IconWrapperHam = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 40px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #EFEFEF;
  }
  onSelect={handleSidenavColor}
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
